/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState, useMemo, useContext } from 'react';

import { TableEntry } from '~components/atoms/FileTables/FileTable.utils';
import FileVersionsContext, {
  FileVersionsCtx,
} from '~src/contexts/FileVersionsContext';
import FilterRecentContext, {
  FilterRecentCtx,
  getDefaultFilterRecent,
} from '~src/contexts/FilterRecentContext';
import SelectedItemsContext from '~src/contexts/SelectedItemsContext';

import RightSideNav from '../../molecules/RightSideNav/RightSideNav';
import RightSideView from '../../molecules/RightSideView/RightSideView';
import { focusOptions } from '~components/atoms/RightClickOverlay/data';
import SidebarContext from '~src/contexts/SidebarContext';
import {
  MINIMIZED_RIGHT_BLOCK_WIDTH_CSS,
  RIGHT_BLOCK_WIDTH_CSS,
} from '~src/styles/constants';

const RightDisplay = () => {
  // context of all the selected files from the table
  const { isSidebarMinimized } = useContext(SidebarContext);

  const [isUnassignedItemsVisible, setIsUnassignedItemsVisible] = useState(
    true
  );
  const [selectedForDetails, setSelectedForDetails] = useState<
    TableEntry | undefined
  >();
  /** cross folder selected table entries, has to be fully custom on top of Table selection */
  const [selectedItems, setSelectedItems] = useState<TableEntry[]>([]);
  const [selectedItemsContext, setSelectedItemsContext] = useState<any>([]);
  const selectedItemsContextChanged = useMemo(
    () => ({ selectedItemsContext, setSelectedItemsContext }),
    [selectedItemsContext, setSelectedItemsContext]
  );

  // context of selected file versions
  const [fileVersionsContext, setFileVersionsContext] = useState<
    FileVersionsCtx['fileVersionsContext']
  >([]);
  const fileVersionsContextChanged = useMemo(
    () => ({ fileVersionsContext, setFileVersionsContext }),
    [fileVersionsContext, setFileVersionsContext]
  );

  // context of filters (recent files)
  const [filterRecentContext, setFilterRecentContext] = useState<
    FilterRecentCtx['filterRecentContext']
  >(getDefaultFilterRecent());
  const filterRecentContextChanged = useMemo(
    () => ({ filterRecentContext, setFilterRecentContext }),
    [filterRecentContext, setFilterRecentContext]
  );

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'strech',
        width: isSidebarMinimized
          ? MINIMIZED_RIGHT_BLOCK_WIDTH_CSS
          : RIGHT_BLOCK_WIDTH_CSS,
        height: '100%',
      }}>
      <SelectedItemsContext.Provider value={selectedItemsContextChanged}>
        <FileVersionsContext.Provider value={fileVersionsContextChanged}>
          <FilterRecentContext.Provider value={filterRecentContextChanged}>
            <RightSideNav
              focusOptions={focusOptions}
              isUnassignedItemsVisible={isUnassignedItemsVisible}
              onChangeIsUnassignedTenderFolders={() => {
                setIsUnassignedItemsVisible((prev) => {
                  if (!prev) {
                    setSelectedForDetails(undefined);
                    setSelectedItems([]);
                  }
                  return !prev;
                });
              }}
            />
            <RightSideView
              focusOptions={focusOptions}
              isUnassignedItemsVisible={isUnassignedItemsVisible}
              setIsUnassignedItemsVisible={setIsUnassignedItemsVisible}
              selectedForDetails={selectedForDetails}
              setSelectedForDetails={setSelectedForDetails}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
            />
          </FilterRecentContext.Provider>
        </FileVersionsContext.Provider>
      </SelectedItemsContext.Provider>
    </div>
  );
};

export default RightDisplay;
